<template>
  <v-dialog v-model="dialog" width="50vw">
    <template v-slot:activator="{}">
      <v-tooltip bottom>
        <template v-slot:activator="{on: onT}">
          <v-btn icon v-on="onT" @click.stop="dialog = !dialog">
            <v-icon color="primary">mdi-lock</v-icon>
          </v-btn>
        </template>
        <span class="text-capitalize">{{ $t("publicar") }}</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title class="primary white--text">
        {{ $t("dialog_titulo") }}
        <v-spacer/>
        <v-btn icon color="error" @click="cerrar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-2">
        <p>{{ $t("dialog_texto_1") }}</p>
        <p>{{ $t("dialog_texto_2") }}</p>
        <v-alert v-if="material.solicitadaPublicacion" color="warning white--text">
          {{ $t("dialog_texto_publicado") }}
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn class="error" depressed @click="cerrar">{{ $t("cerrar") | capitalize }}</v-btn>
        <v-btn color="primary" :loading="solicitando" :disabled="material.solicitadaPublicacion" @click="solicitar">
          {{ $t("btn_aceptar") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {HttpHelper} from "@/comunes/helpers/HttpHelper";

export default {
  name: "BtnDuplicarMaterial",
  props: {
    material: {type: Object, required: true},
  },
  data: () => ({
    publicado: false,
    publicando: false,
    dialog: false,
    solicitando: false
  }),
  methods: {
    cerrar() {
      this.dialog = false;
    },
    solicitar() {
      this.solicitando = true;
      HttpHelper.get(`material-personalizado/${this.material.id}/publicar`)
          .then(() => {
            this.cerrar();
            this.$emit("solicitada");
          })
          .finally(() => {
            this.solicitando = false;
          });
    }
  },
}
</script>

<style scoped>

</style>

<i18n>
{
  "es": {
    "publicar": "Publicar",
    "dialog_titulo": "Publicación material",
    "dialog_texto_1": "Al publicar este material el usuario garantiza que los datos introducidos son veraces y responden a una política publicitaria leal.",
    "dialog_texto_2": "Para validar la autenticidad del usuario y de la empresa de la que forman parte, los responsables de Solconcer comprobarán esta información previamente a la autorización de la publicación.",
    "dialog_texto_publicado": "Ya se ha solicitado la publicación del material, debe esperar a que los responsables de Solconcer la autoricen.",
    "btn_aceptar": "Aceptar y solicitar publicación"
  }
}
</i18n>
